/* eslint-disable @typescript-eslint/no-unused-expressions */
import { initStateFromUrl } from "./customFunctions/paramsURL";

export var wix_url_load_params = null;
export var wix_current_url = null;
export var wix_url_base = null;

export function postMessagesListener(event) {
  let receivedMessage = event.data;
  if (receivedMessage == "undefined") {
    return;
  }
  if (receivedMessage == undefined) {
    return;
  }
  if (receivedMessage == null) {
    return;
  }
  if (typeof receivedMessage !== "string") return;

  if (receivedMessage.includes("WIX_URL_LOAD|")) {
    console.log("WIX_URL_LOAD");

    return;
  }
  if (receivedMessage.includes("WIX_CURRENT_URL|")) {
    wix_current_url = receivedMessage.replace("WIX_CURRENT_URL|", "");
    return;
  }
  if (receivedMessage.includes("WIX_URL_LOAD_Params|")) {
    console.log('WIX LOADED PARAMS');
    
    wix_url_load_params = receivedMessage.replace("WIX_URL_LOAD_Params|", "");
    wix_url_load_params && initStateFromUrl(wix_url_load_params);
    return;
  }
  if (receivedMessage.includes("URL_Params|")) {
    return;
  }
  if (receivedMessage.includes("WIX_URL_BASE|")) {
    wix_url_base = receivedMessage.replace("WIX_URL_BASE|", "");
    return;
  }

  if (receivedMessage.includes("WIX_IS_LOADED|")) {
    return;
  }
}
